export var getReviewerCategoryAndStayDateString = function getReviewerCategoryAndStayDateString(reviewerCategory, reviewerStayDate) {
  return "".concat(reviewerCategory, " ").concat(reviewerStayDate ? "".concat(reviewerCategory ? '| ' : '', " ").concat(reviewerStayDate) : '');
};